import { useEffect, useState } from 'react';

/**
 * Debounce the provided value for the provided time and return only after
 * the `delay` has elapsed. This is useful, for example, if someone is typing a search
 * and we want to wait for the term to settle before issuing a search.
 *
 * @param value the value to debounce
 * @param delay the time in milliseconds to wait before returning the changed value
 */
export function useDebounce<T extends any>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
}
